import { InvalidAmountError } from './errors.js';
/** The two assets the exchange trades. Chains never appear here. */
export const ASSETS = ['GAJU', 'USDC'];
/** Decimal places each asset uses on its own chain. */
export const DECIMALS = {
    // aeternity convention: 1 GAJU = 10^18 aettos.
    GAJU: 18,
    // USDC is 6 decimals on every chain it exists on.
    USDC: 6,
};
/** Minor units in one whole unit of the asset. */
export const MINOR_PER_UNIT = {
    GAJU: 10n ** BigInt(DECIMALS.GAJU),
    USDC: 10n ** BigInt(DECIMALS.USDC),
};
export function isAsset(value) {
    return typeof value === 'string' && ASSETS.includes(value);
}
/** Narrow an untrusted string to an Asset, or fail loudly. */
export function assertAsset(value) {
    if (!isAsset(value)) {
        throw new InvalidAmountError(`Not a known asset: ${String(value)}`);
    }
    return value;
}
//# sourceMappingURL=asset.js.map